import { addHeaderToArray } from "../../addHeaderToArray";
import { addSelectedCommentsToGridElements } from "./addSelectedCommentsToGridElements";
import { addSentimentAnalysisToGridElements } from "./addSentimentAnalysisToGridElements";

export const addCommentsAnalysisToGridElements = (
  newGridElements,
  newHiddenGridElements,
  savedTemplate,
  templateApplied,
  campaigns,
  dataAggregation,
  formatMessage,
) => {
  const aggregation = dataAggregation.commentsAnalysis;

  Object.keys(campaigns).forEach((campaignId) => {
    const {
      sentimentData: { sentimentValues, comments },
      project: { title },
    } = campaigns[campaignId];

    if (campaignId !== "aggregated") {
      const visible = !aggregation && Object.keys(campaigns).length > 1;

      addHeaderToArray(
        title,
        visible ? newGridElements : newHiddenGridElements,
        2,
        `comments-analysis-${campaignId}`,
        savedTemplate,
        templateApplied,
        "comments-analysis",
      );
    }

    addSentimentAnalysisToGridElements(
      newGridElements,
      newHiddenGridElements,
      savedTemplate,
      templateApplied,
      campaigns,
      aggregation,
      formatMessage,
      campaignId,
      sentimentValues,
    );

    addSelectedCommentsToGridElements(
      newGridElements,
      newHiddenGridElements,
      savedTemplate,
      templateApplied,
      campaigns,
      aggregation,
      formatMessage,
      campaignId,
      comments,
    );
  });
};
